import React from "react";

const Image = ({
 url,
 additional_classes,
 styles
}) => {

  return (
    url &&
      <img src={url} key={url} alt="" className={additional_classes ? additional_classes : ''}/>
  );
};

export default Image;